import { render, staticRenderFns } from "./cabinet-user-profile.vue?vue&type=template&id=267b8001&"
import script from "./cabinet-user-profile.vue?vue&type=script&lang=js&"
export * from "./cabinet-user-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267b8001')) {
      api.createRecord('267b8001', component.options)
    } else {
      api.reload('267b8001', component.options)
    }
    module.hot.accept("./cabinet-user-profile.vue?vue&type=template&id=267b8001&", function () {
      api.rerender('267b8001', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/organization/cabinet-user-profile.vue"
export default component.exports